import { Component, Input, OnInit } from "@angular/core";
import { KlDyModalComponent } from "@app/modules/dashboard/components/partials/modal/modal.component";
import * as wjCore from "wijmo/wijmo";

@Component({
  selector: "kl-product-license-history",
  templateUrl: "./product-license-history.component.html",
  styleUrls: ["./product-license-history.component.scss"],
})
export class ProductLicenseHistoryComponent implements OnInit {
  itemsSource: wjCore.CollectionView;
  @Input() mode;
  @Input() modalId: string;
  templateContext: any;
  show: boolean;

  loadingText = "";
  showLoading: boolean;

  constructor(public klModal: KlDyModalComponent) {}

  ngOnInit() {
    if (this.templateContext.hasOwnProperty("data")) {
      this.itemsSource = new wjCore.CollectionView(this.templateContext.data);
      this.show = true;
    }
  }
}
